import React from 'react';
import properties from '../../constants/Properties';
import { expandAudioList } from '../../actions/MenuActions';
import { changeMainAudioCategoryIndex, changeMusicContentIndex, changeSecondAudioCategoryIndex, changeSoundEffectsCategoryIndex } from '../../actions/MusicActions';
import { ScrollableComponent } from '../menus/ScrollableComponent';
import mouseUtils from '../../components/utils/MouseUtils';

const Button = React.createClass({
    getInitialState () {
        return {
            isOver: false,
            clientX: 0,
            clientY: 0
        };
    },
    onMouseIn () {
        this.setState({
            isOver: true
        });
    },
    onMouseOut () {
        this.setState({
            isOver: false
        });
    },
    onMouseDown(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        mouseUtils.mouseDownTime = new Date().getTime();

        const clientPosition = mouseUtils.getTouchPosition(e);

        this.setState({
            clientX: clientPosition.x,
            clientY: clientPosition.y
        });
    },
    onMouseUp(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        const clientPosition = mouseUtils.getTouchPosition(e);

        if (Math.abs(clientPosition.x - this.state.clientX) < 5 && Math.abs(clientPosition.y - this.state.clientY) < 5)
            this.changeCategory();

        if (this.props.refresh)
            this.props.refresh();
    },
    onClick(e) {
        var downTime = new Date().getTime() - mouseUtils.mouseDownTime;

        if (downTime < 1000)
            return;

        this.changeCategory();

        if (this.props.refresh)
            this.props.refresh();
    },
    changeCategory() {
        if (this.props.type == 'soundEffects') {
            if (this.props.selectedIndex != this.props.index) {
                this.props.dispatch(changeSoundEffectsCategoryIndex(this.props.index));
                this.props.dispatch(expandAudioList(false, 'all'));
            }
        } else
        if (this.props.type == 'main') {
            if (this.props.selectedIndex != this.props.index) {
                this.props.dispatch(changeMainAudioCategoryIndex(this.props.index));
                this.props.dispatch(expandAudioList(false, 'all'));

                if (this.props.isAdvancedMenu) {
                    if (this.props.index == 2)
                        this.props.dispatch(changeMusicContentIndex(1));
                    else
                        this.props.dispatch(changeMusicContentIndex(0));
                }
            }
        } else {
            if (this.props.selectedIndex != this.props.index) {
                this.props.dispatch(changeSecondAudioCategoryIndex(this.props.index));
                this.props.dispatch(expandAudioList(false, 'all'));
            }
        }
    },
    render() {
        var iconColor;
        var buttonColor;

        if (this.state.isOver == true) {
            iconColor = properties.CONTEXT_HOVER_COLOR;
            buttonColor = properties.SLIDE_MENU_HOVER_COLOR;
        } else {
            iconColor = 'black';
            buttonColor = properties.SLIDE_MENU_COLOR;
        }

        var topPosition = this.props.index * properties.EFFECTS_BUTTON_HEIGHT;
        const cornerOffset = 14;
        var scrollWidth = properties.EFFECTS_PADDING;

        if (this.props.dataProviderLength < 4)
            scrollWidth = 0;

        const buttonWidth = this.props.accordionWidth - 2 * properties.EFFECTS_PADDING  - 2 * cornerOffset - scrollWidth;

        const buttonStyle = {
            position: 'absolute',
            backgroundColor: buttonColor,
            width: buttonWidth,
            height: properties.EFFECTS_BUTTON_HEIGHT,
            display: 'flex',
            alignItems: 'center',
            paddingLeft: properties.BROWSER_LEFT_PADDING / 2,
            top: topPosition,
            color: 'white',
            margin: 0,
            paddingRight: 0,
            paddingTop: 0,
            paddingBottom: 0,
            boxSizing: 'initial',
            fontSize: 'initial',
            borderStyle: 'none',
            textAlign: 'left'
        };

        var iconVisible;
        var rightPosition = 12;

        const spanStyle = {
            color: iconColor,
            cursor: 'default',
            fontSize: 14,
            whiteSpace: 'nowrap',
            display: 'inline-block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            width: buttonWidth - rightPosition - 20,
            top: 0
        };

        if (this.props.dataProviderLength < 4)
            rightPosition = rightPosition + 6;

        if (this.props.index == this.props.selectedIndex)
            iconVisible = 'block';
        else
            iconVisible = 'none';

        const iconStyle = {
            position: 'absolute',
            top: 13,
            right: rightPosition,
            color: iconColor,
            display: iconVisible
        };

        return (
            <button aria-label={this.props.value} style={buttonStyle} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut} onClick={this.onClick} onTouchStart={this.onMouseDown} onTouchEnd={this.onMouseUp} onMouseDown={this.onMouseDown} onMouseUp={this.onMouseUp}>
                <span style={spanStyle}>{this.props.value}</span>
                <i style={iconStyle} className='fa fa-check'></i>
            </button>
        );
    }
});

export const AudioCategorySelectorNew = React.createClass({
    getInitialState() {
        return {
            isOver: false
        };
    },
    onMouseIn () {
        this.setState({
            isOver: true
        });
    },
    onMouseOut () {
        this.setState({
            isOver: false
        });
    },
    onExpand (e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        var isExpanded = this.props.isExpanded;

        if (isExpanded == undefined)
            isExpanded = false;

        this.refs.mainButton.blur();
        this.props.dispatch(expandAudioList(!isExpanded, this.props.type));
    },
    refreshView() {
        setTimeout(this.refresh, 3);
    },
    refresh() {
        this.forceUpdate();
    },
    render() {
        var elements = [];
        var i;
        const dataProvider = this.props.dataProvider;

        for (i=0; i<dataProvider.length; i++) {
            elements.push(<Button accordionWidth={this.props.accordionWidth} isAdvancedMenu={this.props.isAdvancedMenu} index={i} dataProviderLength={dataProvider.length} selectedIndex={this.props.selectedIndex} type={this.props.type} dispatch={this.props.dispatch} key={'audioCategory' + dataProvider[i] + '_' + Math.random()} value={dataProvider[i]} refresh={this.refreshView}/>);
        }

        var height = properties.CATEGORY_SELECTOR_HEIGHT;
        var listHeight;

        var visibleItems = 8;

        switch (true) {
            case (window.innerHeight <= 440): {
                visibleItems = 3;
                break;
            }

            case (window.innerHeight <= 495): {
                visibleItems = 4;
                break;
            }

            case (window.innerHeight <= 595): {
                visibleItems = 5;
                break;
            }

            case (window.innerHeight <= 650): {
                visibleItems = 6;
                break;
            }
        }

        if (this.props.dataProvider.length < visibleItems)
            listHeight = this.props.dataProvider.length * properties.EFFECTS_BUTTON_HEIGHT;
        else
            listHeight = visibleItems * properties.EFFECTS_BUTTON_HEIGHT;

        if (this.props.isExpanded == true)
            height = height + listHeight + 4;

        var display = 'none';

        if (this.props.visible == true)
            display = 'block';

        const categoryStyle = {
            position: 'absolute',
            top: this.props.top,
            width: this.props.accordionWidth,
            height: height,
            overflowX: 'hidden',
            overflowY: 'hidden',
            display: display,
            zIndex: 10000
        };

        var borderColor;
        var textColor;

        if (this.state.isOver == true) {
            borderColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
            textColor = borderColor;
        } else {
            borderColor = 'black';
            textColor = 'black';
        }

        const buttonWidth = this.props.accordionWidth - 2 * properties.EFFECTS_PADDING;
        const buttonHeight = height - 2 * properties.CATEGORY_SELECTOR_GAP;
        const paddingLeft = 18;

        const categoryButtonStyle = {
            width: buttonWidth,
            height: buttonHeight,
            background: 'white',
            position: 'absolute',
            left: properties.EFFECTS_PADDING,
            top: properties.CATEGORY_SELECTOR_GAP,
            alignItems: 'center',
            margin: 0,
            padding: 0,
            boxSizing: 'initial',
            fontSize: 'initial',
            borderStyle: 'none',
            textAlign: 'left'
        };

        const lineStyle = {
            width: buttonWidth - 2 * paddingLeft,
            height: 2,
            background: borderColor,
            position: 'absolute',
            left: paddingLeft,
            top: properties.CATEGORY_SELECTOR_HEIGHT - 2 * properties.CATEGORY_SELECTOR_GAP - 5
        };

        var icon;

        if (this.props.isExpanded == true)
            icon = 'fa fa-angle-down';
        else
            icon = 'fa fa-angle-right';

        const categoryIconStyle = {
            position: 'absolute',
            top: 12,
            right: 21,
            color: textColor
        };

        const spanStyle = {
            position: 'absolute',
            color: textColor,
            cursor: 'default',
            fontSize: 16,
            top: 11,
            paddingLeft: paddingLeft,
            width: buttonWidth - 55,
            height: 20,
            whiteSpace: 'nowrap',
            display: 'inline-block',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        };

        var listDisplay;

        if (this.props.isExpanded == true) {
            listDisplay = 'block';
        }   else {
            listDisplay = 'none';
        }

        const listWidth = this.props.accordionWidth - 2 * properties.EFFECTS_PADDING - 2 * properties.EFFECTS_CORNER_GAP + 2;
        const categoryListStyle = {
            position: 'absolute',
            width: listWidth,
            height: properties.EFFECTS_BUTTON_HEIGHT * visibleItems,
            top: properties.CATEGORY_SELECTOR_HEIGHT - properties.CATEGORY_SELECTOR_GAP + 2,
            left: properties.EFFECTS_PADDING + properties.EFFECTS_CORNER_GAP,
            borderColor: properties.EFFECTS_BUTTON_BORDER_COLOR,
            borderWidth: 1,
            borderStyle: 'solid',
            display: listDisplay,
            overflowY: 'auto',
            overflowX: 'hidden'
        };

        var componentProperties = {};
        componentProperties.paddingTop = 0;
        componentProperties.paddingLeft = 0;
        componentProperties.width = listWidth;
        componentProperties.height = properties.EFFECTS_BUTTON_HEIGHT * visibleItems;
        componentProperties.scrollHeight = height = properties.EFFECTS_BUTTON_HEIGHT * elements.length;
        componentProperties.top = 0;
        componentProperties.displayState = 'block';
        componentProperties.elements = elements;

        return (
            <div id='categorySelector' style={categoryStyle}>
                <button ref="mainButton" aria-label={this.props.dataProvider[this.props.selectedIndex]} style={categoryButtonStyle} onTouchEnd={this.onExpand} onClick={this.onExpand} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut}>
                    <span style={spanStyle}>{this.props.dataProvider[this.props.selectedIndex]}</span>
                    <i style={categoryIconStyle} className={icon}></i>
                    <div style={lineStyle}/>
                </button>
                <div style={categoryListStyle}>
                    <ScrollableComponent componentProperties={componentProperties}/>
                </div>
            </div>
        );
    }
});



/** WEBPACK FOOTER **
 ** ./src/components/menus/AudioCategorySelectorNew.js
 **/